var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32529 0.171522C6.71734 0.441528 6.7809 0.934015 6.46726 1.27152L2.07312 6L6.46726 10.7285C6.7809 11.066 6.71734 11.5585 6.32529 11.8285C5.93323 12.0985 5.36115 12.0438 5.04751 11.7063L0.199047 6.48889C-0.0665658 6.20307 -0.0665658 5.79693 0.199047 5.51111L5.04751 0.293744C5.36115 -0.0437635 5.93323 -0.0984842 6.32529 0.171522Z",
    fill: "#202A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3253 0.171522C12.7173 0.441528 12.7809 0.934015 12.4673 1.27152L8.07312 6L12.4673 10.7285C12.7809 11.066 12.7173 11.5585 12.3253 11.8285C11.9332 12.0985 11.3611 12.0438 11.0475 11.7063L6.19905 6.48889C5.93343 6.20307 5.93343 5.79693 6.19905 5.51111L11.0475 0.293744C11.3612 -0.0437635 11.9332 -0.0984842 12.3253 0.171522Z",
    fill: "#202A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrows);
export default __webpack_public_path__ + "static/media/leftArrows.db15781f916b3c0bce1d6b6ef4c3e645.svg";
export { ForwardRef as ReactComponent };